<template>
  <div>
    <!-- <el-tabs tab-position="top" style="height: auto" v-model="tabName" @tab-click="handleClick">
      <el-tab-pane label="全部培训活动" name="first">
        <stuTrainIndex v-if="tabName=='first'"></stuTrainIndex>
      </el-tab-pane>
      <el-tab-pane label="我报名的活动" name="second">
        <mySignUpActivity v-if="tabName=='second'"></mySignUpActivity>
        <cultivate v-if="tabName=='second'"></cultivate>
      </el-tab-pane>
    </el-tabs> -->
    <cultivate></cultivate>
  </div>
</template>

<script>
import cultivate from "page/xSchool/stuManager/cultivate.vue";
import stuTrainIndex from "page/xSchool/56xStuManager/stuTrainIndex.vue";
export default {
  data() {
    return {
        tabName: "first",
    };
  },
  components: {
    cultivate,
    stuTrainIndex
  },
  created(){
  },
  methods:{
    handleClick(){
          
    }
  }
};
</script>

<style>
</style>
